var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoSettlements(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 40 40",
    preserveAspectRatio: "xMidYMid meet",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.4992 4H10C8.89543 4 8 4.89543 8 6V34C8 35.1046 8.89543 36 10 36H30.75V34.75H32V6.50085L30.75 5.25085V34.75H10C9.58579 34.75 9.25 34.4142 9.25 34V6C9.25 5.58579 9.58579 5.25 10 5.25H30.7492L29.4992 4ZM12 9H28V10.25H12V9ZM28 12.9006H12V14.1506H28V12.9006ZM19 16.8042H28V18.0542H19V16.8042ZM26.918 25.478C26.852 24.246 25.917 23.751 24.751 23.751C23.574 23.751 22.727 24.257 22.727 25.082C22.727 25.896 23.42 26.193 24.487 26.435L25.312 26.622C26.808 26.963 27.831 27.48 27.831 28.844C27.831 30.12 26.852 30.989 25.169 31.11V32.298H24.3V31.099C22.65 30.967 21.561 30.087 21.374 28.657V28.492H22.342C22.496 29.834 23.53 30.329 24.762 30.329C25.983 30.329 26.83 29.834 26.83 28.921C26.83 27.997 26.071 27.744 24.993 27.502L24.168 27.315C22.672 26.974 21.726 26.391 21.726 25.115C21.726 23.927 22.705 23.091 24.344 22.97V21.782H25.213V22.981C26.797 23.124 27.754 23.982 27.886 25.313V25.478H26.918Z",
    fill: "#5B47FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoSettlements);
export default __webpack_public_path__ + "static/media/no_settlements.46aab07b73621332e83e9b571a9aa893.svg";
export { ForwardRef as ReactComponent };